module.exports = __webpack_public_path__ + "img/P150T_weapon_73.f2a29445.png";